var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatsBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 99,
    viewBox: "0 0 361 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_4437_16432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.757184 79.2528C-1.66742 89.3174 5.95964 99 16.3122 99H344.688C355.04 99 362.667 89.3174 360.243 79.2527L344.102 12.2527C342.371 5.06526 335.94 0 328.547 0H32.4528C25.0597 0 18.6292 5.06526 16.8977 12.2527L0.757184 79.2528Z",
    fill: "black",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.24328 79.3699C-1.10556 89.12 6.28316 98.5 16.3122 98.5H344.688C354.717 98.5 362.106 89.1199 359.757 79.3698L343.616 12.3698C341.939 5.40697 335.709 0.5 328.547 0.5H32.4528C25.2907 0.5 19.0612 5.40697 17.3838 12.3698L1.24328 79.3699Z",
    stroke: "url(#paint0_linear_4437_16432)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_4437_16432",
    x: -11.6953,
    y: -12,
    width: 384.391,
    height: 123,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4437_16432"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4437_16432",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4437_16432",
    x1: -14.7527,
    y1: -13.6125,
    x2: -14.7527,
    y2: 99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsBoxIcon);
export default __webpack_public_path__ + "static/media/statsBox_icon.e4cc9d794b7fe947637728fa0e39bac9.svg";
export { ForwardRef as ReactComponent };